import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import Diversity1Icon from '@mui/icons-material/Diversity1';
import SportsScoreIcon from '@mui/icons-material/SportsScore';
import classImg from '../../data/images/classImg.png';
import competeImg from '../../data/images/competeImg.png';
import noticeImg from '../../data/images/notice.png';

import { styled } from '@mui/material/styles';
import ButtonBase from '@mui/material/ButtonBase';

import img_01 from '../../data/icons/main_03.png';
import img_02 from '../../data/icons/main_01.png';
import img_03 from '../../data/icons/main_02.png';
import img_04 from '../../data/icons/main_11.png';


type Props = {}

const images = [
    {
    url: noticeImg,
    title: '공지사항',
    width: '33.3%',
    },
    {
    url: competeImg,
    title: '교육 방침',
    width: '33.3%',
    },
    {
    url: classImg,
    title: '프로그램 안내',
    width: '33.3%',
    },
];


const ImageButton = styled(ButtonBase)(({ theme }) => ({
    position: 'relative',
    height: 200,
    [theme.breakpoints.down('sm')]: {
    width: '100% !important', // Overrides inline-style
    height: 100,
    },
    '&:hover, &.Mui-focusVisible': {
    zIndex: 1,
    '& .MuiImageBackdrop-root': {
        opacity: 0.15,
    },
    '& .MuiImageMarked-root': {
        opacity: 0,
    },
    '& .MuiTypography-root': {
        border: '4px solid currentColor',
    },
    },
}));

const ImageSrc = styled('span')({
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundSize: 'cover',
    backgroundPosition: 'center 40%',
});

const Image = styled('span')(({ theme }) => ({
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.common.white,
}));

const ImageBackdrop = styled('span')(({ theme }) => ({
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundColor: theme.palette.common.black,
    opacity: 0.4,
    transition: theme.transitions.create('opacity'),
}));

const ImageMarked = styled('span')(({ theme }) => ({
    height: 3,
    width: 18,
    backgroundColor: theme.palette.common.white,
    position: 'absolute',
    bottom: -2,
    left: 'calc(50% - 9px)',
    transition: theme.transitions.create('opacity'),
}));


const mock = [
        {
        title: '신체 활동을 통한 운동 능력 향상',
        subtitle:
            '다양한 놀이 및 훈련을 통해 신체 능력을 향상시키고, 체력을 향상 시킬 수 있습니다.',
            // '',
        icon: (
            <>
                <img src={img_02} width={150}/>
            </>
        ),
        backgroundImg: classImg
        },
        {
        title: '단체 생활을 통한 협응 능력 향상',
        subtitle:
            '축구는 팀스포츠로써 동료와 함께 훈련과 경기를 이어 나가며 협응력을 배울 수 있습니다.',
            // '',
        icon: (
            <>
                <img src={img_03} width={150}/>
            </>
        ),
        backgroundImg: competeImg
        },
        {
        title: '스포츠 정신을 통한 목표 함양',
        subtitle:
            '운동을 통하여 목표를 향한 꾸준한 연습, 인내력과 스포츠 정신을 경험해 볼 수 있습니다.',
            // '',
        icon: (
            <>
                <img src={img_04} width={150}/>
            </>
        ),
        backgroundImg: noticeImg
        },
    ];

const Features = (props: Props) => {
    return (
        <Box sx={{
            width: '100%'
            // '@media (max-width: 1300px)': {
            //     width: '100%'
            // }
        }}>
        <Box marginBottom={4}>
            <Typography sx={{ textAlign: 'center' }}>
            <img src={img_01} width={150} />
            </Typography>
            <Typography
                    sx={{
                    textTransform: 'uppercase',
                    fontWeight: '600',
                    }}
                    gutterBottom
                    color={'primary.main'}
                    align={'center'}
                >
                    Goal of Yonsei
                </Typography>
            <Typography
                fontSize={'2em'}
                gutterBottom
                align={'center'}
                sx={{ 
                    fontWeight: 700,
                    '@media (max-width: 1300px)': {
                        fontSize: '1.5em'
                    }
                }}
            >
                연세 FC 목표
            </Typography>
            <Typography
                fontSize={'1em'}
                // component={'p'}
                color={'text.secondary'}
                align={'center'}
                p={1}
                >
                축구를 통해 자신감을 증진시키고 단체 생활 속 팀 소속감을 느낄 수 있도록 지도하며, <br />상호 존중과 배려심을 배우며 심신이 건강한 올바른 선수로 성장할 수 있도록 합니다.
            </Typography>
            <Box marginTop={3} display={'flex'} justifyContent={'center'}>
            {/* <Button
                variant="outlined"
                color="primary"
                size="large"
            >
                교육 방침 더보기
            </Button> */}
            </Box>
        </Box>
        <Box>
            <Grid container spacing={4}>
            {mock.map((item, i) => (
                <Grid item xs={12} md={4} key={i}>
                <Box
                    data-aos={'fade-up'}
                    data-aos-delay={i * 100}
                    data-aos-offset={100}
                    data-aos-duration={600}
                    // height={1}
                    sx={{ 
                        padding: 3,
                            // '@media (max-width: 1300px)': {
                            //     width: '100vw',
                            //     padding: 'none'
                            // }
                    }}
                >
                    <Box
                        component={Card}
                        variant={'outlined'}
                        height={1}
                        // padding={3}
                        sx={{
                            // backgroundImage: `url(${item.backgroundImg})`,
                            backgroundSize: '100%',
                            // maxHeight: '220px',
                            padding: 3,
                            border: 'none',
                            borderRadius: '15px',
                            boxShadow: 'rgba(0, 0, 0, 0.1) 1px 10px 20px',
                            transition: 'all .2s ease-in-out',
                            '&:hover': {
                                transform: 'translateY(-10px)',
                                boxShadow: 'rgba(0, 0, 0, 0.1) 3px 30px 30px',
                                borderRadius: '15px'
                            },
                            // '@media (max-width: 1300px)': {
                            //     width: '100vw',
                            //     padding: 'none'
                            // }
                        }}
                    >
                    <CardContent>
                        <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                        <Box marginBottom={2} color={'primary.main'}>
                            {item.icon}
                        </Box>
                        <Typography
                            variant={'h6'}
                            color={'black'}
                            gutterBottom
                            sx={{ 
                                fontWeight: 600, 
                                '@media (max-width: 1300px)': {
                                fontSize: '1em'
                            } }}
                        >
                            {item.title}
                        </Typography>
                        <Typography color="black" 
                            sx={{
                                textAlign: 'center',
                                width: '70%',
                                '@media (max-width: 1300px)': {
                                    fontSize: '0.8em'
                                }}}>
                            {item.subtitle}
                        </Typography>
                        </Box>
                    </CardContent>
                    </Box>
                </Box>
                </Grid>
            ))}
            </Grid>
        </Box>
         {/* <Box sx={{ display: 'flex', flexWrap: 'wrap', minWidth: 300, width: '100%', borderRadius: '15px' }}>
        {images.map((image) => (
            <ImageButton
            focusRipple
            key={image.title}
            style={{
                width: image.width,
            }}
            >
            <ImageSrc style={{ backgroundImage: `url(${image.url})` }} />
            <ImageBackdrop className="MuiImageBackdrop-root" />
            <Image>
                <Typography
                component="span"
                variant="subtitle1"
                color="inherit"
                sx={{
                    position: 'relative',
                    p: 4,
                    pt: 2,
                    pb: (theme) => `calc(${theme.spacing(1)} + 6px)`,
                }}
                >
                {image.title}
                <ImageMarked className="MuiImageMarked-root" />
                </Typography>
            </Image>
            </ImageButton>
        ))}
    </Box> */}
        </Box>
    )
}

export default Features